import { render, staticRenderFns } from "./DossierEdit.vue?vue&type=template&id=e4554eaa&"
import script from "./DossierEdit.vue?vue&type=script&lang=ts&"
export * from "./DossierEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4554eaa')) {
      api.createRecord('e4554eaa', component.options)
    } else {
      api.reload('e4554eaa', component.options)
    }
    module.hot.accept("./DossierEdit.vue?vue&type=template&id=e4554eaa&", function () {
      api.rerender('e4554eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DossierEdit.vue"
export default component.exports